import * as c from '@chakra-ui/react'
import { TranslateOptions, translateText } from 'src/utils/translateText'

import Carousel from '../carousel'

interface AppspaceProps {
  appspaceBanner: {
    title: TranslateOptions
    subtitle: TranslateOptions
    items: AppspaceBannerProps[]
    idSection?: string
  }
}

interface AppspaceBannerProps {
  image: string
  url: string
}

export default function Appspace({ appspaceBanner }: AppspaceProps) {
  const [isMobile] = c.useMediaQuery('(max-width: 720px)')

  return (
    <c.Container px={['s5', 0]} id={appspaceBanner?.idSection}>
      <c.Flex borderRadius="20px" direction={['column', 'row']} gap="l2">
        <c.Flex w={['290px', 'full']} direction="column" gap="s5">
          <c.Heading size="md">
            {translateText(appspaceBanner?.title)}
          </c.Heading>
          <c.Text fontSize="t-md.1">
            {translateText(appspaceBanner?.subtitle)}
          </c.Text>
        </c.Flex>

        <c.Box maxW={['full', '923px']}>
          <Carousel
            data={appspaceBanner?.items}
            Content={Content}
            slidesPerView={isMobile ? 1 : 3}
          />
        </c.Box>
      </c.Flex>
    </c.Container>
  )
}

function Content({ data }: { data: AppspaceBannerProps }) {
  return (
    <c.Link isExternal href={data.url}>
      <c.Image
        src={data.image}
        alt={data.url}
        h="364px"
        w={['full', '311px']}
        objectFit="cover"
        borderRadius="12px"
      />
    </c.Link>
  )
}
